import React from 'react';

const variants = {
  body: 'text-base leading-6',
  small: 'text-sm leading-5',
  title: 'text-[32px] leading-10 font-medium',
  caption: 'text-xs leading-[18px]',
  hero: 'text-2xl leading-8',
  link: 'text-base leading-6 font-medium text-stone-800 cursor-pointer',
  heading: 'text-[24px] leading-[32px] font-semibold tracking-[0px]',
  table: 'text-xl leading-[30px] font-medium',
  table_header: 'text-[14px] leading-[20px] font-bold',
  table_content: 'text-[12px] leading-[20px]',
};

const PText = ({
  children,
  variant = 'body',
  as: Component = 'p',
  className = '',
  ...props
}) => {
  return (
    <Component
      className={`font-poppins m-0 ${variants[variant] || variants.body} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default PText;
